/**
 * Normalize and validate phone input for Firebase SMS MFA (E.164: + then digits only).
 * @param {string} input
 * @returns {{ e164: string, error: null } | { e164: null, error: string }}
 */
export function normalizeAndValidateMfaPhone(input) {
  const trimmed = String(input ?? "").trim();
  if (!trimmed) {
    return { e164: null, error: "Enter a phone number." };
  }
  if (!trimmed.startsWith("+")) {
    return {
      e164: null,
      error: "Include your country code with + (e.g. +1 for US).",
    };
  }
  if (trimmed.includes("+", 1)) {
    return { e164: null, error: "Use a single + at the start, then your number." };
  }
  if (/[^+\d\s\-().]/.test(trimmed)) {
    return {
      e164: null,
      error: "Use only digits, spaces, and parentheses after the + sign.",
    };
  }
  const digitsOnly = trimmed.slice(1).replace(/\D/g, "");
  if (digitsOnly.length < 8) {
    return {
      e164: null,
      error: "That number looks too short. Check your country and area code.",
    };
  }
  if (digitsOnly.length > 15) {
    return {
      e164: null,
      error: "That number looks too long. Use at most 15 digits after +.",
    };
  }
  if (digitsOnly[0] === "0") {
    return {
      e164: null,
      error: "Invalid format. The digits after + cannot start with 0.",
    };
  }
  return { e164: `+${digitsOnly}`, error: null };
}
